import IMAGES from "../globals/images"
import "../styles/crick.css"
import Meta from "../components/Meta"
import STRINGS from "../globals/strings"
import AllMatch from '../cards/AllMatch'

function HomePage() {
    const imageClick = (url) => {
        const newWindow = window.open(url, "_blank", "noopener,noreferrer")
        if (newWindow) newWindow.opener = null
    }
    return (
        <div className='app-container'>
            <Meta />
            <div className='header'>
                <img src={IMAGES.LOGO} alt={STRINGS.CRICKSTAR_LOGO_ALT} className="logo" />
            </div>
            {/* <div className="google-ad">
                <img src={IMAGES.GOOGLE_AD} alt={STRINGS.GOOGLE_LOGO_ALT} className="google-logo" />
            </div> */}
            <div className='main-content'>
                <div className="left-banner">
                    <div className="banner-content">
                        <img src={IMAGES.LEFT_BANNER} alt={STRINGS.LEFT_BANNER_ALT} className="banner-logo" />
                        <div className="left-buttons" style={{ cursor: "pointer" }}>
                            <img
                                src={IMAGES.GOOGLE_PLAY}
                                alt={STRINGS.GOOGLE_PLAY_ALT}
                                className="left-button"
                                onClick={() => imageClick(STRINGS.GOOGLE_PLAY_URL_LEFT)}
                            />
                            <img
                                src={IMAGES.APP_STORE}
                                alt={STRINGS.APP_STORE_ALT}
                                className="left-button"
                                onClick={() => imageClick(STRINGS.APP_STORE_URL_LEFT)}
                            />
                        </div>
                    </div>
                </div>
                <AllMatch />
                <div className="right-ad-section">
                    <div className="right-ad">
                        <img src={IMAGES.RIGHT_BANNER} alt={STRINGS.RIGHT_BANNER_ALT} className="right-banner-image" />
                        <div className="ad-content">
                            <div className="ad-text-group">
                                <h2 className="ad-title">{STRINGS.AD_TITLE}</h2>
                                <p className="ad-subtitle">{STRINGS.AD_SUBTITLE}</p>
                            </div>
                            <div className="store-buttons" style={{ cursor: "pointer" }}>
                                <img
                                    src={IMAGES.GOOGLE_PLAY}
                                    alt={STRINGS.GOOGLE_PLAY_ALT}
                                    className="store-button"
                                    onClick={() => imageClick(STRINGS.GOOGLE_PLAY_URL_RIGHT)}
                                />
                                <img
                                    src={IMAGES.APP_STORE}
                                    alt={STRINGS.APP_STORE_ALT}
                                    className="store-button"
                                    onClick={() => imageClick(STRINGS.APP_STORE_URL_RIGHT)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="bottom-banner">
                        <img src={IMAGES.BOTTOM_BANNER} alt={STRINGS.BOTTOM_BANNER_ALT} className="bottom-banner-image" />
                        <div className="bottom-buttons" style={{ cursor: "pointer" }}>
                            <img
                                src={IMAGES.GOOGLE_PLAY}
                                alt={STRINGS.GOOGLE_PLAY_ALT}
                                className="bottom-button"
                                onClick={() => imageClick(STRINGS.GOOGLE_PLAY_URL_BOTTOM)}
                            />
                            <img
                                src={IMAGES.APP_STORE}
                                alt={STRINGS.APP_STORE_ALT}
                                className="bottom-button"
                                onClick={() => imageClick(STRINGS.APP_STORE_URL_BOTTOM)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomePage;